
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/remind-password",
      function () {
        return require("private-next-pages/remind-password.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/remind-password"])
      });
    }
  